import React from "react"
import Cabecalho from "../Cabecalho"
import { ComponentePrincipal } from "./components/ComponentePrincipal"

export function ListarProdutos() {
    return (
        <>
            <Cabecalho pagina="Produtos e Adicionais mais vendidos" />
            <ComponentePrincipal />
        </>
    )
}
